/**
 * AI Coach API client — Growth Platform Phase 3 PR 3.1 + Phase 3 PR 3.2.
 *
 * Обёртки над /api/v1/coach/* (backend PR 3.1) и /coach/chat|conversations|suggested-prompts (PR 3.2).
 */

import { apiFetch } from './core'

const BASE = '/coach'

export const apiSendCoachMessage = ({ content, phase, roleHint } = {}) =>
    apiFetch(`${BASE}/message`, {
        method: 'POST',
        body: JSON.stringify({
            content,
            phase: phase || null,
            role_hint: roleHint || null,
        }),
    })

export const apiGetCoachHistory = (limit = 50) =>
    apiFetch(`${BASE}/history?limit=${Math.min(Math.max(1, limit), 200)}`)

export const apiClearCoachHistory = () =>
    apiFetch(`${BASE}/history`, { method: 'DELETE' })

export const apiGetCoachQuota = () => apiFetch(`${BASE}/quota`)

// ── PR 3.2 — Layout-level AI Coach Pane ────────────────────────────────────

export const apiCoachChat = ({ message, conversationId, phase, roleHint } = {}) =>
    apiFetch(`${BASE}/chat`, {
        method: 'POST',
        body: JSON.stringify({
            message,
            conversation_id: conversationId || null,
            phase: phase || null,
            role_hint: roleHint || null,
        }),
    })

export const apiCoachConversations = (limit = 20) =>
    apiFetch(`${BASE}/conversations?limit=${Math.min(Math.max(1, limit), 100)}`)

export const apiCoachSuggestedPrompts = () =>
    apiFetch(`${BASE}/suggested-prompts`)

// P3 — warm handoff: notify HR (no conversation content shared)
export const apiCoachSupportRequest = ({ note = null } = {}) =>
    apiFetch(`${BASE}/support-request`, {
        method: 'POST',
        body: JSON.stringify({ consent: true, note: note || null }),
    })
